@if (hideAllPageWhileLoading === false) {
  <header>
    <h1>{{ lesson?.get('metadatas').title }}</h1>
    <button  (click)="navigateToLessonList()"
    aria-label="Retour aux leçons">{{'activities.return_to_list' | translate}}</button>
  </header>
  <main>
    @if (!loading) {
      <mat-tab-group
        [selectedIndex]="selectedIndex"
        (selectedIndexChange)="onTabChange($event)">
        @for (subLesson of subLessons; track subLesson; let i = $index) {
          <mat-tab label="{{subLesson?.get('metadatas')?.title}}" appAriaTitle>
            @if (isTips) {
              <app-tips [label]="'generic.activities.tips' | translate"></app-tips>
            }
            <!-- Liste des activités -->
            @if (activities[subLesson.id]?.length > 0) {
              <ul>
                @for (activity of activities[subLesson.id]; track activity; let i = $index) {
                  <li>
                    <app-activty-card [isActivitiesIsDone]="isActivitiesIsDone(activity)"
                      [title]="activity?.get('metadatas')?.title"
                      [image]="getActivityTypeImage(activity)" [subLesson]="subLesson"
                    [i]="i" (playEvent)="playEvent($event)"></app-activty-card>
                  </li>
                }
              </ul>
            } @else {
              @if (activitiesLoaded) {
                <p class="no-activities">{{ getNoActivitiesMessage(subLesson?.get('metadatas')?.title) }}</p>
              }
            }
            <!-- Message si pas d'activités -->
          </mat-tab>
        }
      </mat-tab-group>
    } @else {
      <div class="spinner-wrapper">
        <mat-spinner></mat-spinner>
      </div>
    }
  </main>
} @else {
  <div class="spinner-wrapper">
    <mat-spinner></mat-spinner>
  </div>
}

